const steps = [
  {
    title: "Free Site Survey",
    body: "We visit your premises anywhere in Ireland to assess your specific cleaning needs.",
  },
  {
    title: "Tailored Quotation",
    body: "You receive a transparent, itemised price proposal within 24 hours.",
  },
  {
    title: "Elite Cleaning Execution",
    body: "Our managed family-led team delivers flawless standards with zero disruption to your day.",
  },
  {
    title: "Quality Check & Sign-Off",
    body: "We personally inspect the results with you to guarantee 100% satisfaction.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white py-28 md:py-40 border-t border-[#E5EBF2]"
    >
      <div className="container-ags">
        <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-5">
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
              06 — How It Works
            </span>
            <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[1.0] tracking-[-0.035em] text-[#050B14]">
              Four <span className="italic-display font-normal text-[#0E2A57]">simple steps</span> from first call to flawless finish.
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-[#475569] text-lg md:text-2xl leading-[1.55] self-end">
            No long contracts to start. No hidden fees. Just transparent
            scoping, a clear quote, and a quality sign-off after every clean.
          </p>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-4">
          <div className="hidden md:block absolute left-0 right-0 top-[27px] h-px bg-[#0E2A57]/15" />
          {steps.map((s, i) => (
            <li
              key={s.title}
              data-testid={`process-step-${i + 1}`}
              className="relative pt-0 pb-8 md:pb-0 md:pr-8 md:border-l-0 border-t border-[#E5EBF2] md:border-t-0 first:border-t-0"
            >
              <div className="flex items-center gap-4 mb-5">
                <span className="bg-white border-2 border-[#0E2A57] text-[#0E2A57] w-14 h-14 flex items-center justify-center font-heading font-extrabold text-lg tracking-[-0.02em]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-heading font-bold text-xl text-[#050B14] tracking-[-0.025em]">
                {s.title}
              </h3>
              <p className="mt-3 pr-4 text-[#475569] text-base leading-[1.6]">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
